import React, { Component } from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import ConditionedComponent from 'components/ConditionedComponent.js';

class MetalSynthComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMods: false,
        };
    }

    render() {
        let instrument = this.props.instrument;
        return (
            <div className="instrument">
              <div className="instrument-name">
                {this.props.instrument.getName()}
             </div>
              <ConditionedComponent condition={!this.state.showMods}>
                <div className="clear-fix"/>
                <div className="instrument-section">
                  <div className="instrument-subsection">
                    <div className="instrument-subsection-name">
                      Filter
                    </div>
                    <div className="clear-fix"/>
                    <EffectParameterSlider
                      effectNumber={0}
                      name={'Frequency'}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      parameter={instrument.frequencyParameter}
                      onParameterChanged={() => []}
                      isParameter={true}
                      min={0}
                      max={4000}
                      step={1}
                      />
  <EffectParameterSlider
                      effectNumber={0}
                      name={'Resonance'}
                      sequencerEngine={this.props.sequencerEngine}
                      lfoEnabled={true}
                      parameter={instrument.resonanceParameter}
                      onParameterChanged={() => []}
                      isParameter={true}
                      min={0}
                      max={4000}
                      step={1}
                      />
                    <EffectParameterSlider
                      effectNumber={0}
                      name={'Harmonicity'}
                      sequencerEngine={this.props.sequencerEngine}
                      parameter={instrument.harmonicityParameter}
                      lfoEnabled={true}
                      onParameterChanged={() => []}
                      isParameter={true}
                      min={0}
                      max={200}
                      step={0.0001}
                      />
                    <EffectParameterSlider
                      effectNumber={0}
                      name={'Modulation Index'}
                      sequencerEngine={this.props.sequencerEngine}
                      parameter={instrument.modulationIndexParameter}
                      lfoEnabled={true}
                      onParameterChanged={() => []}
                      isParameter={true}
                      min={0}
                      max={20}
                      step={0.0001}
                      />
                  </div>
                </div>
                <div className="instrument-section">
                  <div className="instrument-subsection">
                    <div className="instrument-subsection-name">
                      Amp/Filter Envelope
                    </div>
                    <div className="clear-fix"/>
              <EffectParameterSlider
                effectNumber={0}
                name={'Attack'}
                parameter={instrument.attackParameter}
                sequencerEngine={this.props.sequencerEngine}
                onParameterChanged={() => []}
                lfoEnabled={true}
                isParameter={true}
                min={0}
                max={6000}
                step={1}
                />
                <EffectParameterSlider
                  effectNumber={0}
                  name={'Decay'}
                  sequencerEngine={this.props.sequencerEngine}
                  parameter={instrument.decayParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  lfoEnabled={true}
                  min={0}
                  max={6000}
                  step={1}
                  />
                  <EffectParameterSlider
                    effectNumber={0}
                    name={'Sustain'}
                    parameter={instrument.sustainParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    sequencerEngine={this.props.sequencerEngine}
                    lfoEnabled={true}
                    min={0}
                    max={1}
                    step={0.01}
                    />
                    <EffectParameterSlider
                      effectNumber={0}
                      sequencerEngine={this.props.sequencerEngine}
                      name={'Release'}
                      parameter={instrument.releaseParameter}
                      onParameterChanged={() => []}
                      lfoEnabled={true}
                      isParameter={true}
                      min={0}
                      max={10000}
                      step={1}
                      />
                  </div>
                </div>
              </ConditionedComponent>
            </div>);
    }
}

export default MetalSynthComponent;
